import styled from 'styled-components';
import {
  sharedButtonStyles,
  type ButtonStyleProps,
} from '#/component-lib/base-components/styled-buttons';

export const StyledButton = styled.button<ButtonStyleProps>`
  ${props => sharedButtonStyles(props)}

  &[type='submit'] {
    // override user agent stylesheet setting on iOS Safari
    font-weight: normal;
  }
`;
